import {
  fontSize,
  maxBreakpoints,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { inset, mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text, fonts } = theme;

export const featuredProductContainer = css`
  justify-content: center;
  display: flex;
  margin: ${stack(24)};
  position: relative;

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      margin: ${stack(spacing.xxxl)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${stack(55)};
    `,
  )};
`;

export const featuredProduct = css`
  display: flex;
  flex-direction: row;
  flex-basis: ${pxToRem(600)};
`;

/**
 * #1: -webkit-mask-image fixes an issue Safari had with using border-radius with overflow: hidden
 *     on a container with an absolutely positioned element inside it.
 *     https://stackoverflow.com/questions/49066011/overflow-hidden-with-border-radius-not-working-on-safari
 */
export const productImage = css`
  position: relative;
  flex-basis: 50%;
  min-width: 50%;
  margin-right: ${pxToRem(spacing.xl)};
  overflow: hidden;
  width: 100%;
  padding-bottom: 100%;
  border-radius: ${pxToRem(10)};

  ${/* See comment #1 */ ''}
  -webkit-mask-image: -webkit-radial-gradient(white, black);

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-radius: ${pxToRem(spacing.lg)};
    `,
  )};
`;

export const productImageContainer = css`
  flex-basis: 50%;
  margin-right: ${pxToRem(spacing.xl)};
  min-width: 50%;
`;

export const productTitle = css`
  margin: ${stack(spacing.sm)};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${fontSize(text.HEADING.LG)}

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
      ${fontSize(text.BODY.SM)}
    `,
  )};
`;

export const productPriceWrapper = css`
  display: flex;
  margin: ${stack(spacing.sm)};
`;

export const price = css`
  margin: 0;
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${fontSize(text.HEADING.MD)}

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      ${fontSize(text.BODY.SM)}
    `,
  )};
`;

export const salePrice = css`
  ${price};
  margin-left: ${pxToRem(spacing.xs)};
`;

export const productInfo = css`
  position: relative;
  flex-direction: column;
  display: flex;
`;

export const productLinkIcon = css`
  display: inline-block;
  margin: 0 0 ${pxToRem(2)} ${pxToRem(spacing.base)};
`;

export const productAnchorWrapper = css`
  flex-basis: ${pxToRem(600)};
  color: inherit;
  text-decoration: none;
`;

export const productLink = css`
  text-align: left;
  white-space: nowrap;
  text-decoration: underline;
  color: var(--brand-purple-base);
`;

export const freeDelivery = css`
  gap: ${pxToRem(spacing.xs)};
  display: inline-flex;
  width: fit-content;
  white-space: nowrap;
  padding: ${inset(spacing.xs, spacing.base)};
  margin: ${stack(spacing.sm)};
  border-radius: ${pxToRem(8)};
  background-color: var(--neutral-black-10);
  color: var(--neutral-black-base);
  ${fontSize(text.BODY.XS)}
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${fontSize(text.BODY.SM)}
      margin: ${stack(spacing.md)};
    `,
  )};
`;

export const favouriteButton = css`
  position: absolute;
  bottom: 0;
  right: ${pxToRem(spacing.xs)};
  margin-bottom: ${pxToRem(spacing.xs)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      right: ${pxToRem(spacing.md)};
      margin-bottom: ${pxToRem(spacing.md)};
    `,
  )};
`;

export const favouriteButtonWrapper = css`
  position: absolute;
  bottom: 0;
`;
